const defProtocol = process.env.VUE_APP_REST_SSL ? "https" : "http";
const defHost = process.env.VUE_APP_REST_HOST || "localhost";
const defPORT = process.env.VUE_APP_REST_PORT || 3000;
const useConfiguredUrl = process.env.VUE_APP_USER_REST_CONFIG || false;
const defADMName = process.env.VUE_APP_ADM_NAME || "uploader";

const appVersion = require("../package.json").version;

let baseUrl;
if (useConfiguredUrl) {
    baseUrl = `${defProtocol}://${defHost}:${defPORT}`;
} else {
    baseUrl = process.env.BASE_URL;
    if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.substr(0, baseUrl.length - 1);
    }
    if (baseUrl.endsWith("/w2d")) {
        baseUrl = baseUrl.substr(0, baseUrl.length - 3);
    }
    if (baseUrl === "/") {
        baseUrl = window.location.href;
        let idx = baseUrl.indexOf("/w2d/#");
        if (idx < 0) {
            idx = baseUrl.indexOf("/w2d#");
        }
        if (idx < 0) {
            if (baseUrl.endsWith("/w2d/")) {
                idx = baseUrl.length - 5;
            }
            if (baseUrl.endsWith("/w2d")) {
                idx = baseUrl.length - 4;
            }
        }
        if (idx >= 0) {
            baseUrl = baseUrl.substr(0, idx);
        }
    }
    if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.substr(0, baseUrl.length - 1);
    }
    console.log("using baseurl", baseUrl);
}

const getAppOption = (name, defaultValue) => {
    const value = process.env[`VUE_APP_${name}`];
    if (typeof value !== "undefined") {
        return value;
    }
    return defaultValue;
};

module.exports = {
    baseUrl: baseUrl,
    appName: defADMName,
    appVersion: appVersion,
    ui: {
        showSingleContentSendBtn: false
    },
    images: {
        maxWidth: getAppOption("PREVIEW_MAX_WIDTH", 1000),
        format: getAppOption("PREVIEW_FORMAT", "webp")
    }
};
